import menu from './menu';
import cart from './cart';
import tree from './tree';
import bottomBar from './bottomBar';

export default { menu, cart, tree, bottomBar };